import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { vscDarkPlus, } from "react-syntax-highlighter/dist/cjs/styles/prism";

export default function MarkdownRenderer({ children }) {
    return (
        <Markdown
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeRaw]}

            components={{
                code({ node, inline, className, children: codeChildren, ...props }) {
                    const match = /language-(\w+)/.exec(className || "");

                    return !inline && match ? (
                        <SyntaxHighlighter
                            style={vscDarkPlus}
                            customStyle={{ padding: '1rem' }}
                            PreTag="div"
                            language={match[1]}
                            {...props}
                        >
                            {codeChildren}
                            {/* {String(codeChildren).replace(/\n$/, "")} */}
                        </SyntaxHighlighter>
                    ) : (
                        <code className={className} {...props}>

                            {codeChildren}
                        </code>
                    );
                },
                h2({ node, children, ...props }) {
                    if (!children) return
                    return (
                        <p
                            style={{ fontSize: '1.4rem', fontWeight: 600 }}
                            {...props}
                        >
                            {children}
                        </p>
                    );
                },
                h1({ node, children, ...props }) {
                    if (!children) return
                    return (
                        <p
                            style={{ fontSize: '1.6rem', fontWeight: 700 }}
                            {...props}
                        >
                            {children}
                        </p>
                    );
                },
                p({ node, children, ...props }) {
                    if (!children) return
                    return (
                        <p
                            style={{ padding: '.2rem 0rem' }}
                            {...props}
                        >
                            {children}
                        </p>
                    );
                },
                a({ node, children, ...props }) {
                    if (!children) return
                    return (
                        <a
                            target="_blank"
                            {...props}
                        >
                            {children}
                        </a>
                    );
                },
                ul({ node, children, ...props }) {
                    if (!children) return
                    return (
                        <ul
                            style={{ padding: '.6rem 0rem' }}
                            {...props}
                        >
                            {children}
                        </ul>
                    );
                },
                ol({ node, children, ...props }) {
                    if (!children) return
                    return (
                        <ol
                            style={{ padding: '.6rem 0rem' }}
                            {...props}
                        >
                            {children}
                        </ol>
                    );
                },
                li({ node, children, ...props }) {
                    if (!children) return
                    return (
                        <li
                            style={{ padding: '0rem 0rem', display: 'block', width: '100%' }}
                            {...props}
                        >
                            {children}
                        </li>
                    );
                },
                table({ node, children, ...props }) {
                    return (
                        <div style={{
                            border: '1px solid var(--lighterGrey)',
                            borderRadius: '.4rem',
                            overflow: 'auto',
                            margin: '.4em 0',
                        }}>
                            <table
                                style={{
                                    width: '100%',
                                    borderCollapse: 'collapse',
                                    borderStyle: 'hidden',
                                    fontSize: 'inherit',
                                }}
                                {...props}
                            >
                                {children}
                            </table>
                        </div>
                    );
                },
                thead({ node, children, ...props }) {
                    return (
                        <thead {...props}>
                            {children}
                        </thead>
                    );
                },
                th({ node, children, ...props }) {
                    return (
                        <th
                            style={{
                                backgroundColor: 'var(--lighterGrey)',
                                padding: '.45rem .6rem',
                                textAlign: 'left',
                                border: '1px solid var(--lightGrey)',
                                fontSize: '.8em',
                                fontWeight: 600,
                                textTransform: 'uppercase',
                                whiteSpace: 'nowrap',
                            }}
                            {...props}
                        >
                            {children}
                        </th>
                    );
                },
                td({ node, children, ...props }) {
                    return (
                        <td
                            style={{
                                padding: '.45rem .6rem',
                                textAlign: 'left',
                                border: '1px solid var(--lighterGrey)',
                                verticalAlign: 'top',
                                wordBreak: 'normal',
                            }}
                            {...props}
                        >
                            {children}
                        </td>
                    );
                },
                tr({ node, children, ...props }) {
                    return (
                        <tr {...props}>
                            {children}
                        </tr>
                    );
                },
                hr() {
                    return <br />;
                },

            }}
        >
            {children}
        </Markdown>
    );
}